export default {
      id: "generator-switch-usage",
      viewBox: "0 0 48 53",
      url: __webpack_public_path__ + "img/icons.svg#generator-switch",
      toString: function () {
        return this.url;
      }
    }